import { getQualityBandColor } from '../../helpers/getQualityBandColor'
import { TQualityBand } from '../../models'

import styles from './QualityDonut.module.scss'

interface IQualityDonutProps {
  score: number
  band: TQualityBand
}

export const QualityDonut = ({ score, band }: IQualityDonutProps) => {
  const color = getQualityBandColor(band)

  return (
    <div
      className={styles.donut}
      style={{
        background: `conic-gradient(${color} ${score * 3.6}deg, #eef2f6 0deg)`,
      }}
    >
      <div className={styles.donutInner}>
        <div className={styles.donutScore}>{score}</div>
        <div className={styles.donutTotal}>/ 100</div>
      </div>
    </div>
  )
}
